import { apiGet, apiPost, apiPatch } from '@/utils/api';
import getPath from '@/utils/getPath';
import { handleApiError } from '@/utils/errorHandler';

export const exportApi = {
  /**
   * Fetches exports, optionally filtered by export type.
   * @apiRoute GET '/user-exports/<export_type>' or '/user-exports'
   */
  async getExports(exportType = '') {
    try {
      const url = exportType
        ? getPath(`user-exports/${exportType}`)
        : getPath('user-exports/');
      const response = await apiGet(url);
      return response.data;
    } catch (err) {
      await handleApiError(err, 'getExports');
    }
  },

  /**
   * Creates a new export job.
   * @apiRoute POST '/user-exports/<service_type>/<export_type>' or '/user-exports/<service_type>'
   */
  async createExport({ serviceType, exportType, filters, pagination, alias }) {
    try {
      const url = exportType
        ? getPath(`user-exports/${serviceType}/${exportType}`)
        : getPath(`user-exports/${serviceType}`);
      const response = await apiPost(url, {
        filter: filters,
        pagination,
        alias,
      });
      return response.data;
    } catch (err) {
      await handleApiError(err, 'createExport', true, 'Error creating export');
    }
  },

  /**
   * Patches an existing export entry.
   * @apiRoute PATCH '/user-exports/<int:export_id>'
   */
  async updateExport(exportId, updates) {
    try {
      const allowedFields = [
        'exportAlias',
        'status',
        'fileName',
        'url',
        'downloaded',
        'expirationTimest',
      ];
      const payload = Object.fromEntries(
        Object.entries(updates).filter(
          ([key, value]) => value !== undefined && allowedFields.includes(key)
        )
      );
      const response = await apiPatch(
        getPath(`user-exports/${exportId}`),
        payload
      );
      return response.data;
    } catch (err) {
      await handleApiError(err, 'updateExport', true, 'Error updating export');
    }
  },
};
